import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SettingCard } from "@/components/settings/setting-card";
import { isNative } from "@/lib/platform";
import { AccountNotificationSettings } from "../account-notification-settings";
import { BrowserNotificationSettings } from "../browser-notification-settings";
import { NativePushNotificationSettings } from "../native-push-notification-settings";

interface NotificationPreferencesCardProps {
  className?: string;
}

export function NotificationPreferencesCard({ className }: NotificationPreferencesCardProps) {
  const { t } = useTranslation("settings");

  return (
    <SettingCard
      title={t("profile.notificationPreferences")}
      icon={<Bell className="h-5 w-5" />}
      className={className}
    >
      <div className="space-y-6">
        {/* Device-level push permission (browser or native) */}
        {isNative() ? <NativePushNotificationSettings /> : <BrowserNotificationSettings />}

        {/* Account-level: which categories deliver on push / email */}
        <div className="border-t pt-6">
          <AccountNotificationSettings />
        </div>
      </div>
    </SettingCard>
  );
}
